import { lazy } from 'react';
import { getCountryCode } from 'utilities/locales';

// the component must reside in /components, pass in the relative path based off that
const fetchLocalizedComponent = (filepath, overrides = {}) => {
  const storeCode = getCountryCode()?.toLowerCase();
  const fileExt = overrides[storeCode] || storeCode;
  const localizedFilepath = `${filepath}.${fileExt}`;

  return lazy(() =>
    import(
      /* webpackExclude: /\.test/ */ `components/${localizedFilepath}`
    ).catch(
      () => import(/* webpackExclude: /\.test/ */ `components/${filepath}`),
    ),
  );
};

export { fetchLocalizedComponent };
